<!-- TEMPLATE -->
<template>
    <div style="position: relative;">
      <dean-section-title :result="true" :sidemenuButton="true">
        <span slot="title">Offerte</span>
        <div>
          <dean-section-title-item
            v-if="status=='Concept' && $store.getters.getUser.privileges.includes('change-status-quote')"
            :icon="lostIcon"
            @click.native="loseQuote"
            :content="true">
            Weigeren
          </dean-section-title-item>
          <dean-section-title-item
            v-if="(status=='Gewonnen' || status=='Concept') && $store.getters.getUser.privileges.includes('change-status-quote')"
            :icon="wonIcon"
            @click.native="winQuote"
            :content="true">
            Bestellen
          </dean-section-title-item>
        </div>
      </dean-section-title>
        <transition name="fade" mode="out-in" style="position: absolute;" v-if="isLoading">
          <dean-load-overlay></dean-load-overlay>
        </transition>
        <dean-table
            v-if="quote"
            :data="quote"
            :columns="tableColumns"
            :subHeaders="subHeaders"
        ></dean-table>
    </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import { deanDialogBus } from '@/main';
import axios from 'axios';

// COMPONENTS & ICONS
import {
  wonIcon,
  lostIcon,
  deanSectionTitle,
  deanSectionTitleItem,
  deanTable,
  deanLoadOverlay,
} from '@deanone/dean-components';
import {formatPrice} from '@/mixins/formatPrice';

@Component({
  components: {
    wonIcon,
    lostIcon,
    deanSectionTitle,
    deanSectionTitleItem,
    deanTable,
    deanLoadOverlay,
  },
})

export default class QuoteSummary extends Vue {
  // PROPS
  @Prop() public partnerId!: string;
  @Prop() public customerId!: string;
  @Prop() public quoteId!: string;
  @Prop() public quoteNumber!: string;
  @Prop() public trigger!: string;
  public quote: object | null = null;
  public links: object | null = null;
  public wonIcon: object = wonIcon;
  public lostIcon: object = lostIcon;
  public isLoading: boolean = false;
  public status: string = '';
  public baseUrl: string = '/-/trade/api/quote.summary';
  public subHeaders: any = [
    'Horizon',
    'Internet',
    'Mobile Wholesale',
    'Mobile Wholesale KPN',
    'Mobile Wholesale Odido',
    'Mobiel',
    'Odido Mobiel',
    'KPN Mobiel',
    'SIP Trunk',
    'Totaal',
  ];
  public tableColumns: any = {
    amount: {
        content: 'Aantal',
        align: 'left',
        sort: false,
        dql: 'amount',
    },
    description: {
        content: 'Omschrijving',
        align: 'left',
        sort: false,
        dql: 'description',
    },
    term: {
        content: 'Termijn',
        align: 'left',
        sort: false,
        dql: 'term',
    },
    connectPrice: {
        content: 'Eenmalig',
        align: 'left',
        sort: false,
        dql: 'connectPrice',
    },
    recurringPrice: {
        content: 'Maandelijks',
        align: 'left',
        sort: false,
        dql: 'recurringPrice',
    },
    recurringCommission: {
        content: 'Korting',
        align: 'left',
        sort: false,
        dql: 'recurringCommission',
    },
  };

  public mounted() {
    this.update();
  }

  @Watch('trigger')
  public update(value?: any, newValue?: any) {
    this.isLoading = true;
    axios.post(this.baseUrl, {
        id: this.quoteId,
      }).then(
        (response) => {
          this.status = response.data.status;
          this.quote = response.data.lines.map((quote: any) => {
            return {
              annotation: quote.annotation,
              amount: quote.amount,
              description: quote.description,
              term: quote.term,
              connectPrice: formatPrice(quote.connectPrice),
              recurringPrice: formatPrice(quote.recurringPrice),
              recurringCommission: formatPrice(quote.recurringCommission),
              recurringCommissionPercentage: formatPrice(quote.recurringCommissionPercentage),
            };
          });
          this.isLoading = false;
        },
        (error) => {
          // tslint:disable-next-line:no-console
          console.error(error);
          this.isLoading = false;
        },
      );
  }

  public winQuote() {
    deanDialogBus.$emit('open', 'QuoteWinDialog', {
      id: this.quoteId,
      customerId: this.customerId,
      partnerId: this.partnerId,
    });
  }

  public loseQuote() {
    deanDialogBus.$emit('open', 'QuoteLoseDialog', {
      id: this.quoteId,
      customerId: this.customerId,
      partnerId: this.partnerId,
      number: this.quoteNumber,
    });
  }

}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '~@deanone/dean-components/src/scss/vars';

:deep(.dean-load-overlay) {
  position: absolute;
  min-height: calc(100vh - 80px);

  .dean-overlay {
    position: absolute;
  }
}
</style>
